import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Row, Badge, Empty, Skeleton, Tooltip } from 'antd';
import { listColors } from '../../../Utils/DashBoardUtils';
import ColourChart from '../../D3Charts/ColourChart';
import InsightList from './InsightList';
import styles from './Insight.module.scss';
import { EmptyMarketSkillsIcon } from '../../../Icons/AryaIcons';
import { menuItemsList } from '../../../Utils/GlobalInsightSupplyUtil';
import eventTypes from '../../../Analytics/EventTypes';
import jobMessage from '../../JobForm/JobMessages';

export default function SkillsInsightView(props) {
  const { listOfSkillsStats, totalCount, loading, readonlyStats, emptyInsightDescription } = props;
  const [skillsListView, setSkillsListView] = React.useState(false);

  React.useEffect(() => {
    if (skillsListView) {
      setSkillsListView(false);
    }
  }, [loading]);

  const skillsInsightTitle = (
    <div className={styles.headerTitle}>
      <FormattedMessage {...jobMessage.marketSkills} />
    </div>
  );
  const skillsInsightDescription = (
    <div className={styles.headerDescription}>
      <FormattedMessage {...jobMessage.skillSnapDescription} />
    </div>
  );
  return (
    <div className={styles.supplyContent} id={menuItemsList.marketSkills.id}>
      {skillsListView ? (
        <>
          <div className={styles.headerSupplyInfo} id="SkillsListHeader">
            <div className={styles.headerInfo}>
              {skillsInsightTitle}
              <div className={styles.headerButton}>
                <Button
                  size="small"
                  onClick={() => setSkillsListView(false)}
                  sk-event-name={eventTypes.job.marketIntel.hideSkillList}
                >
                  X
                </Button>
              </div>
            </div>
            {skillsInsightDescription}
          </div>
          <div id="SkillsList">
            <InsightList insightList={listOfSkillsStats} loading={loading} itemSpan={11} />
          </div>
        </>
      ) : (
        <>
          <div className={styles.headerSupplyInfo}>
            <div className={styles.headerInfo}>
              {skillsInsightTitle}
              <div className={styles.headerButton}>
                <Button
                  size="small"
                  disabled={listOfSkillsStats.length < 1}
                  onClick={() => setSkillsListView(true)}
                  sk-event-name={eventTypes.job.marketIntel.displaySkillList}
                >
                  {' '}
                  <FormattedMessage {...jobMessage.seeListLabel} />{' '}
                </Button>
              </div>
            </div>
            {skillsInsightDescription}
          </div>
          <div>
            <Skeleton active paragraph={{ rows: 5 }} loading={loading}>
              <Row>
                <div className={styles.colorMapView}>
                  <ColourChart list={listOfSkillsStats} totalCount={totalCount} />
                </div>
              </Row>
              <div className={styles.insightListView}>
                {listOfSkillsStats.length > 0 ? (
                  <>
                    {listOfSkillsStats.slice(0, 15).map((item, i) => (
                      <Badge
                        color={listColors[i]}
                        className={styles.skillsListView}
                        text={
                          <Tooltip key={item.DisplayName} title={item.DisplayName}>
                            {item.DisplayName} ({item.SupplyPercentage}%)
                          </Tooltip>
                        }
                      />
                    ))}
                  </>
                ) : (
                  <div>
                    <Empty
                      image={<EmptyMarketSkillsIcon className={styles.emptyIcon} />}
                      description={
                        <div>
                          <h3>
                            <FormattedMessage {...jobMessage.noSkillsFoundLabel} />
                          </h3>
                          {!readonlyStats ? <div>{emptyInsightDescription}</div> : null}
                        </div>
                      }
                    />
                  </div>
                )}
                {/* </Row> */}
              </div>
            </Skeleton>
          </div>
        </>
      )}
    </div>
  );
}
